/** Remove UTF-8 BOM if present */
export function stripBom(text: string): string {
  if (text.length > 0 && text.charCodeAt(0) === 0xfeff) return text.slice(1);
  return text;
}

/**
 * RFC‑4180–style CSV (quoted fields, escaped quotes).
 * Rows with only empty cells are dropped.
 */
export function parseCsv(content: string): string[][] {
  const text = stripBom(content.replace(/\r\n/g, "\n").replace(/\r/g, "\n"));
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i]!;
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
          continue;
        }
        inQuotes = false;
        continue;
      }
      field += c;
      continue;
    }

    switch (c) {
      case '"':
        inQuotes = true;
        break;
      case ",":
        row.push(field);
        field = "";
        break;
      case "\n":
        row.push(field);
        rows.push(row.map((cell) => cell.trim()));
        row = [];
        field = "";
        break;
      default:
        field += c;
    }
  }

  row.push(field);
  rows.push(row.map((cell) => cell.trim()));

  return rows.filter((r) => r.some((cell) => cell.length > 0));
}
